// The owner's discount depends on how the referred studio pays: a share of its monthly
// subscription for a few months, or a share of its yearly subscription credited at once.
export const Referral_Monthly_Discount_Percent = 15;
export const Referral_Monthly_Discount_Months = 3;
export const Referral_Yearly_Discount_Percent = 8;
// The referred studio's reward for naming who sent them: a longer free trial.
export const Referral_Trial_Days = 45;
export const Default_Trial_Days = 30;
